// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__26wue","col":"CardReaderDesc_col__uGqfs","label":"CardReaderDesc_label__DmQAX"};